import { httpService } from '../..';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { ICart, ICartLineUpdateItemRequest } from './cartsInterfaces';

export async function fetchCart(cartId: number): Promise<IApiExecuteRespone<ICart>> {
  const response: IApiExecuteRespone<ICart> = { requestFailed: false };

  try {
    const apiResponse = await httpService.get(ApiUrls.carts(cartId));
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function addCartItem(request: ICartLineUpdateItemRequest): Promise<IApiExecuteRespone<any>> {
  const response: IApiExecuteRespone<any> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.cartLines(request.cartId), request);
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}
